import { render, staticRenderFns } from "./jggs.vue?vue&type=template&id=2dd36542&scoped=true"
import script from "./jggs.vue?vue&type=script&lang=js"
export * from "./jggs.vue?vue&type=script&lang=js"
import style0 from "./jggs.vue?vue&type=style&index=0&id=2dd36542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd36542",
  null
  
)

export default component.exports